//Represents the max columns used in calculator grids
export default [ ...Array(4).keys() ];